import api from './api';

export const getEmails = ({ page = 1, search = '', sortBy = '', sortOrder = '' } = {}) =>
  api.get(`/api/v1/messages?page=${page}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`);

export const createCampaign = (payload) => api.post('/api/v1/messages', payload);

export const getContactLists = () => api.get('/api/v1/messages/lists');
export const getContactList  = (id) => api.get(`/api/v1/messages/lists/${id}`);
export const createContactList = (payload) => api.post('/api/v1/messages/lists', payload);
export const deleteContactList = (id) => api.delete(`/api/v1/messages/lists/${id}`);
export const addUsersToList      = (id, users) => api.post(`/api/v1/messages/lists/${id}/users`, { user_ids: users });
export const removeUsersFromList = (id, users) => api.delete(`/api/v1/messages/lists/${id}/users`, { data: { user_ids: users } });

export const getCampaigns     = ()           => api.get('/api/v1/messages/campaigns');
export const getCampaign      = (id)         => api.get(`/api/v1/messages/campaigns/${id}`);
export const createCampaignDraft = (payload) => api.post('/api/v1/messages/campaigns', payload);
export const updateCampaign   = (id, payload) => api.patch(`/api/v1/messages/campaigns/${id}`, payload);
export const deleteCampaign   = (id)         => api.delete(`/api/v1/messages/campaigns/${id}`);
